export default "__VITE_ASSET__PmA2YSGr__"